var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { City } from 'packages/location/City';
import { Region } from 'packages/location/Region';
import { Country } from 'packages/location/Country';
var Location = /** @class */ (function (_super) {
    __extends(Location, _super);
    function Location() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.city = new City();
        _this.region = new Region();
        _this.country = new Country();
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Location.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (jsonData.city) {
            this.city = EntityBuilder.buildOne(City, jsonData.city);
        }
        return this;
    };
    var _a, _b, _c;
    __decorate([
        Type(City),
        __metadata("design:type", typeof (_a = typeof City !== "undefined" && City) === "function" ? _a : Object)
    ], Location.prototype, "city", void 0);
    __decorate([
        Type(Region),
        __metadata("design:type", typeof (_b = typeof Region !== "undefined" && Region) === "function" ? _b : Object)
    ], Location.prototype, "region", void 0);
    __decorate([
        Type(Country),
        __metadata("design:type", typeof (_c = typeof Country !== "undefined" && Country) === "function" ? _c : Object)
    ], Location.prototype, "country", void 0);
    return Location;
}(Entity));
export { Location };
